import { render, staticRenderFns } from "./OtherParticipantCard.vue?vue&type=template&id=32760857&scoped=true"
import script from "./OtherParticipantCard.vue?vue&type=script&lang=js"
export * from "./OtherParticipantCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32760857",
  null
  
)

export default component.exports